import MarketMapPicker from "../../components/MarketMapPicker";
import {
  cardStyle,
  ghostButtonStyle,
  primaryButtonStyle,
  SectionTitle,
  surfaceStyle,
} from "../dashboardStyles";
import { getPermissionBadgeStyle } from "../dashboardUtils";

function StatCard({ label, value, helper }) {
  return (
    <div
      style={{
        padding: 18,
        borderRadius: 20,
        background: "#fff7ed",
        border: "1px solid #fed7aa",
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 700, color: "#9a3412" }}>{label}</div>
      <div style={{ marginTop: 10, fontSize: 24, fontWeight: 800 }}>{value}</div>
      <div style={{ marginTop: 8, color: "#7c2d12" }}>{helper}</div>
    </div>
  );
}

export default function MapPage({
  availableMarketCategories,
  clearSelectedMarket,
  discoveryRadiusLabel,
  handleMapPick,
  handleViewportChange,
  isDiscoveringRadiusMarkets,
  isLoadingMarkets,
  isLocating,
  loadMarketAroundUser,
  mappedMarkets,
  openMarketPage,
  previewMarketSelection,
  requestCurrentLocation,
  selectedCategoryFilters,
  selectedAddressLabel,
  selectedMarket,
  selectedMarketId,
  selectedMarketInsight,
  selectedMapPoint,
  toggleMapCategory,
  t,
  userLocation,
}) {
  return (
    <div style={{ display: "grid", gap: 20 }}>
      <div style={{ ...surfaceStyle, padding: 24 }} className="hero-panel">
        <SectionTitle
          eyebrow={t?.("map.hero.eyebrow", "Mercados reais no mapa") || "Mercados reais no mapa"}
          title={t?.("map.hero.title", "Toque no mercado para ver o resumo antes de abrir") || "Toque no mercado para ver o resumo antes de abrir"}
          description={
            (
              t?.(
                "map.hero.description",
                "Ao autorizar a localizacao, o app puxa automaticamente mercados, supermercados, farmacias, conveniencias, atacadistas e varejistas dentro do raio ativo de {{radius}}."
              ) ||
              "Ao autorizar a localizacao, o app puxa automaticamente mercados, supermercados, farmacias, conveniencias, atacadistas e varejistas dentro do raio ativo de {{radius}}."
            ).replace("{{radius}}", String(discoveryRadiusLabel))
          }
          action={
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button
                onClick={() => requestCurrentLocation({ persistProfile: true })}
                style={primaryButtonStyle}
                disabled={isLocating}
              >
                {isLocating
                  ? t?.("map.hero.locating", "Localizando...") || "Localizando..."
                  : t?.("map.hero.use_location", "Usar minha localizacao") || "Usar minha localizacao"}
              </button>
            </div>
          }
        />

        {availableMarketCategories.length > 0 && (
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 16 }}>
            <button
              onClick={() => toggleMapCategory("")}
              style={selectedCategoryFilters.length === 0 ? primaryButtonStyle : ghostButtonStyle}
            >
              {t?.("map.categories.all", "Todos") || "Todos"}
            </button>
            {availableMarketCategories.map((category) => {
              const isActive = selectedCategoryFilters.includes(category);
              return (
                <button
                  key={category}
                  onClick={() => toggleMapCategory(category)}
                  style={isActive ? primaryButtonStyle : ghostButtonStyle}
                >
                  {category}
                </button>
              );
            })}
          </div>
        )}
      </div>

      <div style={{ display: "grid", gap: 20 }}>
        <div style={{ ...cardStyle, padding: 18 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 12,
              flexWrap: "wrap",
              marginBottom: 14,
            }}
          >
            <div>
              <h3 style={{ margin: 0 }}>
                {t?.("map.integrated.title", "Mapa integrado") || "Mapa integrado"}
              </h3>
              <div style={{ marginTop: 6, color: "#475569" }}>
                {t?.("map.integrated.description", "Toque em um marcador para abrir o resumo do mercado. Depois voce decide se quer entrar na pagina completa dele.") || "Toque em um marcador para abrir o resumo do mercado. Depois voce decide se quer entrar na pagina completa dele."}
              </div>
            </div>
            {(isLoadingMarkets || isDiscoveringRadiusMarkets) && (
              <span style={getPermissionBadgeStyle("prompt")}>
                {t?.("map.integrated.finding_nearby", "Finding nearby stores...") || "Finding nearby stores..."}
              </span>
            )}
          </div>
          <MarketMapPicker
            markets={mappedMarkets}
            userLocation={userLocation}
            selectedMarketId={selectedMarketId}
            selectedPoint={selectedMapPoint}
            onMapPick={handleMapPick}
            onMarketSelect={(market) =>
              previewMarketSelection(
                market,
                `Mercado ${market.market} selecionado no mapa.`
              )
            }
            onViewportChange={handleViewportChange}
            t={t}
          />

          <div
            style={{
              marginTop: 16,
              display: "grid",
              gap: 12,
              padding: 16,
              borderRadius: 18,
              background: "#fff7ed",
              border: "1px solid #fed7aa",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 12,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <div>
                <strong style={{ display: "block" }}>
                  {t?.("map.base.title", "Base da busca") || "Base da busca"}
                </strong>
                <div style={{ marginTop: 6, color: "#7c2d12" }}>
                  {selectedAddressLabel ||
                    t?.("map.base.empty", "Use sua localizacao atual ou um endereco salvo para mudar a area do mapa.") ||
                    "Use sua localizacao atual ou um endereco salvo para mudar a area do mapa."}
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <button onClick={loadMarketAroundUser} style={ghostButtonStyle}>
                  {t?.("map.base.update", "Atualizar mapa") || "Atualizar mapa"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={cardStyle}>
        <SectionTitle
          eyebrow={t?.("map.summary.eyebrow", "Resumo antes de abrir") || "Resumo antes de abrir"}
          title={
            selectedMarket
              ? selectedMarket.market
              : t?.("map.summary.title.empty", "Selecione um mercado no mapa") || "Selecione um mercado no mapa"
          }
          description={
            selectedMarket
              ? t?.("map.summary.description.selected", "Aqui voce ve distancia, confiabilidade e qualidade do mercado antes de entrar na pagina dele.") || "Aqui voce ve distancia, confiabilidade e qualidade do mercado antes de entrar na pagina dele."
              : t?.("map.summary.description.empty", "Toque em um mercado no mapa para abrir o resumo e depois navegar para a pagina daquele mercado.") || "Toque em um mercado no mapa para abrir o resumo e depois navegar para a pagina daquele mercado."
          }
          action={
            selectedMarket ? (
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <button onClick={() => openMarketPage()} style={primaryButtonStyle}>
                  {t?.("map.summary.open_market", "Ir para pagina do mercado") || "Ir para pagina do mercado"}
                </button>
                <button onClick={clearSelectedMarket} style={ghostButtonStyle}>
                  {t?.("map.summary.switch_market", "Trocar mercado") || "Trocar mercado"}
                </button>
              </div>
            ) : null
          }
        />

        {selectedMarket ? (
          <div style={{ display: "grid", gap: 16 }}>
            <div
              style={{
                padding: 18,
                borderRadius: 22,
                background: "#fff1f2",
                border: "1px solid #fecdd3",
              }}
            >
              <div style={{ color: "#475569" }}>
                {selectedMarket.address ||
                  t?.("map.ready.address_missing", "Endereco ainda nao informado") ||
                  "Endereco ainda nao informado"}
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                gap: 14,
              }}
            >
              <StatCard
                label={t?.("common.distance", "Distancia") || "Distancia"}
                value={selectedMarketInsight?.distanceLabel || (t?.("common.no_data", "n/d") || "n/d")}
                helper={t?.("map.summary.distance_helper", "Calculada a partir da localizacao do usuario.") || "Calculada a partir da localizacao do usuario."}
              />
              <StatCard
                label={t?.("common.rating", "Avaliacao") || "Avaliacao"}
                value={selectedMarketInsight?.ratingLabel || (t?.("common.no_data", "n/d") || "n/d")}
                helper={
                  selectedMarketInsight?.priceIndexLabel
                    ? `${t?.("map.summary.price_index", "Indice PennyPantry") || "Indice PennyPantry"} ${selectedMarketInsight.priceIndexLabel}`
                    : t?.("map.summary.rating_helper", "Avaliacao melhora com mais dados.") || "Avaliacao melhora com mais dados."
                }
              />
              <StatCard
                label={t?.("common.reliability", "Confiabilidade") || "Confiabilidade"}
                value={selectedMarketInsight?.reliabilityLabel || "Inicial"}
                helper={`${selectedMarketInsight?.productsCount || 0} ${
                  t?.("map.summary.reliability_helper", "produtos ativos") || "produtos ativos"
                }`}
              />
              <StatCard
                label={t?.("common.last_update", "Ultima atualizacao") || "Ultima atualizacao"}
                value={selectedMarketInsight?.freshestUpdateLabel || (t?.("common.no_data", "n/d") || "n/d")}
                helper={`${selectedMarketInsight?.contributions || 0} ${
                  t?.("map.summary.last_update_helper", "atualizacoes acumuladas") || "atualizacoes acumuladas"
                }`}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              padding: 18,
              borderRadius: 22,
              background: "#fff7ed",
              border: "1px solid #fdba74",
              color: "#9a3412",
            }}
          >
            {t?.("map.summary.manual_point", "O mapa agora abre um resumo do mercado antes da pagina completa. Se quiser explorar outra area, ainda pode tocar em uma parte vazia do mapa.") || "O mapa agora abre um resumo do mercado antes da pagina completa. Se quiser explorar outra area, ainda pode tocar em uma parte vazia do mapa."}
          </div>
        )}
      </div>
    </div>
  );
}
